module.exports = __webpack_public_path__ + "static/media/profile.fe9264ee.jpg";